import { EnumProducts } from "services/caju/enums/enumProducts";
import {
  EnumCalendlyUrls,
  EnumMultipleWithCiclos,
  EnumMultipleWithMultiWithoutCiclos,
  EnumMultipleWithoutMultiWithoutCiclos,
  EnumOnlyCajuMais,
  EnumOnlyCiclos,
  EnumOnlyDespesas,
  EnumOnlyMulti,
  EnumOnlyRewards,
} from "./enums";
import { IStep3FormValues } from "pages/home/step3/useStep3Form/iStep3FormValues";

export const getCalendlyLink = (step3Values?: IStep3FormValues, employeesNumber?: number | "") => {
  if (!employeesNumber || !step3Values) return;

  const {products, interestPlan} = step3Values;

  if (products?.length === 1 && !interestPlan.length) return getLinkFromOneProduct(products[0], employeesNumber);

  return getLinkFromManyProducts(step3Values, employeesNumber);
};

function getLinkFromOneProduct(product: EnumProducts, employeesNumber: number) {
  if (product === EnumProducts.MULTIBENEFITS) {
    if (employeesNumber >= 100) return EnumOnlyMulti["100+"];
    if (employeesNumber >= 20) return EnumOnlyMulti["20-99"];
    return EnumOnlyMulti["1-19"];
  }

  if (product === EnumProducts.AWARDS) {
    if (employeesNumber >= 100) return EnumOnlyRewards["100+"];
    if (employeesNumber >= 20) return EnumOnlyRewards["20-99"];
    return EnumOnlyRewards["1-19"];
  }

  if (product === EnumProducts.CAJU_MAIS) {
    if (employeesNumber >= 100) return EnumOnlyCajuMais["100+"];
    if (employeesNumber >= 20) return EnumOnlyCajuMais["20-99"];
    return EnumOnlyCajuMais["1-19"];
  }

  if (product === EnumProducts.CORP_EXPENSES) {
    if (employeesNumber >= 100) return EnumOnlyDespesas["100+"];
    if (employeesNumber >= 20) return EnumOnlyDespesas["20-99"];
    return EnumOnlyDespesas["1-19"];
  }

  if (product === EnumProducts.CAJU_CICLOS) {
    return EnumOnlyCiclos["1+"];
  }

  return EnumCalendlyUrls.MASSIVO__ALL
}

function getLinkFromManyProducts(step3Values: IStep3FormValues, employeesNumber: number) {

  if(employeesNumber < 20) return EnumCalendlyUrls.MASSIVO__ALL

  const {products} = step3Values;

  const hasCiclos = products?.some((product) => product === EnumProducts.CAJU_CICLOS);
  const hasMulti = products?.some((product) => product === EnumProducts.MULTIBENEFITS);


  if (hasCiclos) {
    if (employeesNumber >= 100) return EnumMultipleWithCiclos["100+"];
    return EnumMultipleWithCiclos["20-99"];
  }

  if (!hasCiclos && hasMulti) {
    if (employeesNumber >= 100) return EnumMultipleWithMultiWithoutCiclos["100+"];
    return EnumMultipleWithMultiWithoutCiclos["20-99"];
  }

  if (!hasCiclos && !hasMulti) {
    if (employeesNumber >= 100) return EnumMultipleWithoutMultiWithoutCiclos["100+"];
    return EnumMultipleWithoutMultiWithoutCiclos["20-99"];
  }

  return EnumCalendlyUrls.MASSIVO__ALL
}
